module.exports = __webpack_public_path__ + "img/7.ef4c77bd.jpg";